import { render, staticRenderFns } from "./PageAPP.vue?vue&type=template&id=7370f413"
import script from "./PageAPP.vue?vue&type=script&lang=js"
export * from "./PageAPP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports